'use client';

import Button from '@/components/atoms/button';
import Markdown from '@/components/atoms/markdown';
import React from 'react';

const NewsAndEventsListSection = ({ news }: any) => {

    const truncateDescription = (text: string, maxLength: number = 450) => {
        const summaryEndMatch = text.match(/<!--\s*summaryends\s*-->/);
        if (summaryEndMatch) {
            return text.slice(0, summaryEndMatch.index).trim();
        }
        else if (text.length > maxLength) {
            return `${text.slice(0, maxLength).trim()}...`;
        }
        return text;
    };

    // Handle locale dynamically
    const handleLinkHover = (
        event: React.MouseEvent<HTMLAnchorElement, MouseEvent>,
        href: string
    ) => {
        const domain = window.location.origin; // Get the domain dynamically
        const locale = window?.location?.pathname.split('/')[1] || 'au'; // Get the locale dynamically
        const updatedHref = `${domain}/${locale}${href.startsWith('/') ? href : `/${href}`}`;
        event.currentTarget.setAttribute('href', updatedHref);
    };

    return (
        <div>
            <div
                className={`pb-[92px] pt-3'
            relative mx-auto w-full  px-4 md:px-8 lg:px-10`}
            >
                {news?.length > 0 ? (
                    <div className="">
                        {news?.map((blog: any, index: any) => {
                            // Find the section with `section_with_image_text`
                            const section = blog.sections?.find(
                                (sec: any) => sec.section_with_image_text
                            )?.section_with_image_text;

                            if (!section) {
                                return null; // Skip if no section_with_image_text is found
                            }

                            // Extract additional CSS
                            const cmsCssClass = section.additional_css || '';

                            // Dynamic URL for case studies
                            const modifiedUrl = blog.url;

                            return (
                                <div
                                    key={index}
                                    className={`flex flex-col max-w-[981px] mx-auto ${cmsCssClass}`}
                                >

                                    {/* Title Rendered as Markdown with Padding */}
                                    {section.title && (
                                        <div className={`mb-[27px] ${cmsCssClass}`}>
                                            <Markdown
                                                className="!text-[24px] !leading-[26px] font-semibold text-black"
                                            >{section.title}</Markdown>
                                        </div>
                                    )}

                                    <a
                                        href={modifiedUrl}
                                        onMouseEnter={(event) => handleLinkHover(event, modifiedUrl)}
                                    >
                                        {/* Full-size Image */}
                                        {section.image?.url && (
                                            <img
                                                src={section.image.url}
                                                alt={section.image.title || 'Case Study Image'}
                                                className={`w-full h-auto max-h-[352px] object-cover ${cmsCssClass}`}
                                            />
                                        )}
                                    </a>
                                    {/* Truncated Description */}
                                    {section.description && (
                                        <div className={`mt-[27px] ${cmsCssClass}`}>
                                            <Markdown
                                                className="!text-[16px] !leading-[26px] !text-black !font-medium"
                                            >{truncateDescription(section.description)}</Markdown>
                                        </div>
                                    )}

                                    {/* Dynamic CTA Buttons */}
                                    {section.ctas &&
                                        section.ctas.map((cta: any, ctaIndex: number) => (
                                            cta?.button?.href && (
                                                <div className={`mt-[25px] ${cmsCssClass}`} key={ctaIndex}>
                                                    <a
                                                        href={cta?.button?.href}
                                                        className="text-decoration-none group"
                                                        style={{
                                                            display: 'inline-block', // Restrict hover to button's size
                                                        }}
                                                    >
                                                        <Button
                                                            className="cursor-pointer !text-[16px] !leading-[26px] !font-medium"
                                                            style={{
                                                                backgroundColor: cta.button_background_color?.hex || '#000000',
                                                                border: `1px solid ${cta.button_border_color?.hex || ''}`,
                                                                color: cta.button_text_color?.hex || '#ffffff',
                                                                cursor: 'pointer !important', //  Override the default
                                                                padding: '5px 32px',
                                                                borderRadius: '0',
                                                            }}
                                                        >
                                                            {cta.button.title}
                                                        </Button>
                                                    </a>
                                                </div>
                                            )
                                        ))}
                                    <div className="mt-[49px] mb-[55px] h-[2px] w-full bg-[#D9D9D9]"></div>
                                </div>
                            );
                        })}
                    </div>
                ) : (
                    <p className="text-center text-gray-500">No news or events available at the moment. Please check back later.</p>
                )}
            </div>
        </div>
    );
};

export default NewsAndEventsListSection;
